export default function AccountStatus({ error, children }) {
  if (!error && !children) return null;
  return (
    <p
      role={error ? 'alert' : 'status'}
      className={`rounded-md border px-3 py-3 text-[15px] leading-relaxed ${error ? 'border-red-500/25 bg-red-100 text-red-600' : 'border-line bg-surface-2 text-ink-2'}`}
    >
      {error || children}
    </p>
  );
}
